import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getShortLink, getShortLinkByCode } from "../../appRedux/actions/ShortLink";
import { Skeleton } from "antd";

export default function ShortLinkRedirect() {
  const { code } = useParams();
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (code) {
      getShortLinkByCode(code)
        .then(response => {
          setUrl(response.url);
        })
        .catch(error => {
          setError("Link tidak ditemukan atau sudah tidak aktif.");
        });
    }
  }, [code]);

  useEffect(() => {
    if (url) {
      if (countdown <= 0) {
        window.location.href = url;
        return;
      }

      const timer = setInterval(() => {
        setCountdown(c => c - 1);
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [url, countdown]);

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img alt="example" src="/bg.jpg" />
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                Short Link
              </h1>
              <p>

              </p>
            </div>
            <div className="gx-app-logo">
              <img
                alt="example"
                src="/assets/images/logo-idn.png"
                width="150"
              />
            </div>
          </div>
          <div className="gx-app-login-content">
            {error && <p>{error}</p>}
            {(!url && !error) && <Skeleton active />}
            {url && (
              <div>
                <p>Anda akan diarahkan dalam {countdown} detik...</p>
                <p>
                  Tujuan: <br />
                  <a href={url}>{url}</a>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
